<script lang="ts" setup>
import { nextTick, onMounted, ref } from 'vue';

const wrapperRef = ref<HTMLElement>();

onMounted(async () => {
  // 後からウィジェットを発火させる
  // ref: https://github.com/pinterest/widgets/issues/13#issuecomment-27737036
  //      https://developers.pinterest.com/docs/add-ons/save-button/#Large%20Save%20Button
  await nextTick();
  if (window.parsePinterest) {
    window.parsePinterest(wrapperRef.value);
  }
});
</script>

<template>
  <ClientOnly>
    <div ref="wrapperRef">
      <a
        data-pin-do="buttonPin"
        href="https://www.pinterest.com/pin/create/button/"
        data-pin-tall="true"
        data-pin-save="true"
      />
    </div>
  </ClientOnly>
</template>
